<div class="page">
  <div class="hero">
    <div>
      <h1>Dashboard</h1>
      <p>Visão geral inicial do PeritoDesk.</p>
    </div>

    <button type="button" class="btn-reload" (click)="carregarPericias()" [disabled]="carregando()">
      {{ carregando() ? 'Carregando...' : 'Atualizar' }}
    </button>
  </div>

  <div class="alert" *ngIf="erro()">{{ erro() }}</div>

  <div class="cards">
    <div class="card">
      <strong>Total de perícias</strong>
      <span class="metric">{{ totalPericias() }}</span>
      <small>Registros cadastrados</small>
    </div>

    <div class="card">
      <strong>Status ativos</strong>
      <span class="metric">{{ resumoStatus().length }}</span>
      <small>Situações diferentes encontradas</small>
    </div>

    <div class="card">
      <strong>Módulos Analíticos</strong>
      <span>Ferramentas de apoio técnico.</span>
    </div>
  </div>

  <div class="dashboard-grid">
    <section class="panel">
      <div class="panel-header">
        <div>
          <h2>Perícias por status</h2>
          <p>Distribuição das perícias cadastradas conforme a situação atual.</p>
        </div>
      </div>

      <div class="chart-area" *ngIf="totalPericias() > 0; else semDados">
        <div class="pie-wrap">
          <div class="pie" [style.background]="'conic-gradient(' + graficoPizza() + ')'">
            <div class="pie-center">
              <strong>{{ totalPericias() }}</strong>
              <span>Total</span>
            </div>
          </div>
        </div>

        <div class="legend">
          <div class="legend-row" *ngFor="let item of resumoStatus()">
            <span class="legend-dot" [style.background]="corStatus(item.status)"></span>
            <span class="legend-name">{{ item.status }}</span>
            <strong>{{ item.total }}</strong>
            <span class="legend-percent">{{ item.percentual }}%</span>
          </div>
        </div>
      </div>

      <ng-template #semDados>
        <div class="empty">
          Nenhuma perícia cadastrada para montar o gráfico.
        </div>
      </ng-template>
    </section>
  </div>
</div>
